export const TRAVEL_FUSION: App.FlightProviders = 'travelFusion'
export const AMADEUS: App.FlightProviders = 'amadeus'
export const JETSTAR: App.FlightProviders = 'jetstar'
export const SABRE: App.FlightProviders = 'sabre'
export const CHARTER: App.FlightProviders = 'charter'
